module.exports = __webpack_public_path__ + "img/basic_train.70f45950.png";